import React from "react";
import { useApolloClient } from '@apollo/react-hooks';
import { isEmpty, get } from "lodash";
import gql from "graphql-tag";
import ShareDialog from "./ShareDialog";
import ApiStory from "models/data/api/ApiStory";
import ShareButton from './ShareButton'
import useFirebaseSession from 'hooks/useFirebaseSession'
import { baseUrl } from 'services/shared/Environment'
import { getStorySlug } from 'data/api/ApiStory'

const createOrGetSharedStoryLink = gql`
	mutation createOrGetSharedStoryLink($firebaseId: ID!, $storyId: ID!) {
		createOrGetSharedStoryLink(firebaseId: $firebaseId, storyId: $storyId) {
			id
		}
	}
`;

interface Props {
	apolloClient: any;
	firebaseUserId: string;
	story: any;
}

class ShareSection extends React.Component<Props> {

  state = {
    sharedStoryLinkId: "",
    shareDialogOpen: false
  };

  storySlug = () => getStorySlug(this.props.story)

  storyId = () => ApiStory.id(this.props.story);

  sharedStoryLinkIdRetrieved = () => !isEmpty(this.state.sharedStoryLinkId);

  componentDidMount() {
    const { firebaseUserId } = this.props;
    this.props.apolloClient
      .mutate({
        mutation: createOrGetSharedStoryLink,
        variables: {
          firebaseId: firebaseUserId,
          storyId: this.storyId()
        }
      })
      .then(result => {
        const sharedStoryLinkId = get(
          result,
          "data.createOrGetSharedStoryLink.id",
          ""
        );
        this.setState({ sharedStoryLinkId });
      })
      .catch(error => console.log(error));
  }

  openDialog = () => this.setState({ shareDialogOpen: true });

  closeDialog = () => this.setState({ shareDialogOpen: false });

  shareLink = () =>
    `${baseUrl()}/${this.storySlug()}?s=${
      this.state.sharedStoryLinkId
    }`;

  render() {
    return (
      <>
        <ShareDialog
          open={this.state.shareDialogOpen}
          link={this.shareLink()}
          onClose={this.closeDialog}
          story={this.props.story}
        />
        {this.sharedStoryLinkIdRetrieved() && (
          <ShareButton onClick={() => this.openDialog()} />
        )}
      </>
    );
  }
}

export default ({ story }) => {
    const apolloClient = useApolloClient()
    const { loggedInUserId } = useFirebaseSession()

    return (
        <ShareSection
            apolloClient={apolloClient}
            story={story}
            firebaseUserId={loggedInUserId}
        />
    )
}